import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PropertyTypeService } from '../property-type.service';
import { PropertyType } from '../property-type.model';
@Component({
  selector: 'app-property-type-list',
  templateUrl: './property-type-list.component.html',
  styleUrls: ['./property-type-list.component.css']
})
export class PropertyTypeListComponent implements OnInit {

    public propertyTypes: PropertyType[] = [];
    @Output() updated = new EventEmitter<any>();
    constructor(private propertyTypeService: PropertyTypeService) { }

    async ngOnInit() {
        this.propertyTypes = await this.propertyTypeService.getPropertyTypes();
        this.propertyTypeService.propertyTypeAdded
            .subscribe((propertyType: PropertyType) => {
                this.propertyTypes.push(propertyType);
            });
        this.propertyTypeService.propertyTypeUpdated
            .subscribe((propertyType: PropertyType) => {
                this.propertyTypes.find(x => x.id === propertyType.id).name = propertyType.name;
                this.propertyTypes.find(x => x.id === propertyType.id).productSkillsetId = propertyType.productSkillsetId;
                this.propertyTypes.find(x => x.id === propertyType.id).propertyField = propertyType.propertyField;
                this.propertyTypes.find(x => x.id == propertyType.id).isRetail = propertyType.isRetail;
                this.updated.emit(false);
            });
        this.propertyTypeService.propertyTypeDeleted
            .subscribe((propertyTypeId: string) => {
                var propertyTypeIndex = this.propertyTypes.findIndex(t => t.id === propertyTypeId);
                this.propertyTypes.splice(propertyTypeIndex, 1);
            });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-list/property-type-list.component.ts